import type { DashboardData } from '@/api/dashboard/dashboard.service';
import { http } from '@/lib/http';
import type { ApiError } from '@/types/api/api-error';
import { useQuery } from '@tanstack/react-query';

export type { DashboardData };

export const dashboardKeys = {
  all: ['dashboard'] as const,
  detail: (eventId?: string) => [...dashboardKeys.all, eventId ?? 'next'] as const,
};

export const useDashboard = (eventId?: string) =>
  useQuery<DashboardData, ApiError>({
    queryKey: dashboardKeys.detail(eventId),
    queryFn: async () => {
      const res = await http.get<DashboardData>('dashboard', {
        params: eventId ? { eventId } : {},
      });
      return res.data;
    },
  });
